export enum ArticlesActionType {
  FETCH_ARTICLES = 'FETCH_ARTICLES',
  FETCH_ARTICLES_PUBLIC = 'FETCH_ARTICLES_PUBLIC',
  SEARCH_ARTICLES = 'SEARCH_ARTICLES',
  FETCH_SELECTED_ARTICLE = 'FETCH_SELECTED_ARTICLE',
  FETCH_ARTICLES_TAG = 'FETCH_ARTICLES_TAG',
  FETCH_ARTICLES_PUBLIC_TAG = 'FETCH_ARTICLES_PUBLIC_TAG',
  SEARCH_ARTICLES_PUBLIC = 'SEARCH_ARTICLES_PUBLIC'
}
